import React, { useState } from "react";
import { PaziaSelect, PaziaButton } from "components/atoms";
import { useFormContext } from "react-hook-form";
import { useEmailTemplateOptions, EmailTemplateOption } from "api/hooks/useEmailTemplateOptions";
import { EmailTemplateApi } from "api/emailtemplates/emailtemplatesApi";
import { TemplatePreviewModal } from "./TemplatePreviewModal";

interface TemplateSelectorProps {
  onTemplateSelect: (template: EmailTemplateApi) => void;
  disabled?: boolean;
  className?: string;
}

export const TemplateSelector: React.FC<TemplateSelectorProps> = ({
  onTemplateSelect,
  disabled = false,
  className = "",
}) => {
  const { options, isLoading } = useEmailTemplateOptions();
  const { watch } = useFormContext();
  const selectedTemplateId = watch("selectedTemplate");

  const [previewTemplate, setPreviewTemplate] = useState<EmailTemplateApi | null>(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const handleLoadTemplate = () => {
    if (!selectedTemplateId) return;

    const selectedOption = options.find((opt) => opt.value === selectedTemplateId);
    if (!selectedOption) return;

    // Show confirmation dialog
    const confirmed = window.confirm("Załadowanie szablonu zastąpi aktualną treść emaila. Czy chcesz kontynuować?");

    if (confirmed) {
      onTemplateSelect(selectedOption.template);
    }
  };

  const handlePreview = () => {
    if (!selectedTemplateId) return;

    const selectedOption = options.find((opt) => opt.value === selectedTemplateId);
    if (!selectedOption) return;

    setPreviewTemplate(selectedOption.template);
    setIsPreviewOpen(true);
  };

  const handleClosePreview = () => {
    setIsPreviewOpen(false);
    setPreviewTemplate(null);
  };

  return (
    <div className={`space-y-3 ${className}`}>
      <div>
        <PaziaSelect
          name="selectedTemplate"
          label="Szablon emaila (opcjonalnie)"
          placeholder="Wybierz szablon do wypełnienia..."
          options={options}
          isLoading={isLoading}
          disabled={disabled}
          isClearable={true}
        />
      </div>

      {selectedTemplateId && (
        <div className="flex gap-2">
          <PaziaButton
            btnType="button"
            type="primary"
            onClick={handleLoadTemplate}
            disabled={disabled}
            className="flex-1"
          >
            Załaduj szablon
          </PaziaButton>
          <PaziaButton btnType="button" type="tertiary" onClick={handlePreview} disabled={disabled}>
            Podgląd
          </PaziaButton>
        </div>
      )}

      <TemplatePreviewModal
        template={previewTemplate}
        isOpen={isPreviewOpen}
        onClose={handleClosePreview}
        onLoad={onTemplateSelect}
      />
    </div>
  );
};
